import React from 'react';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import DropzoneComponent from 'components/Dropzone';
import FieldRow from 'components/FormElements/FieldRow';
import CkEditor from 'components/CkEditor';
import RecordView from 'components/RecordView';
import { Control, Controller } from 'react-hook-form';
import { TrancheFormInput } from '../useTrancheForm';
import { UploadedFile } from 'components/Dropzone';

const useStyles = makeStyles()(() => ({
  marginLeftBtn: {
    marginLeft: 10,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

type Props = {
  control: Control<TrancheFormInput>;
  handleCancel: () => void;
  handleClickConfirmationEmailCustomisation: () => void;
  id: string;
  onAttachmentDrop: (files: Array<UploadedFile>) => Promise<void>;
  onAttachmentRemove: () => void;
  buttonDisabled: boolean;
  formDisabled: boolean;
};

const ConfirmationEmailCustomisation: React.FC<Props> = ({
  control,
  handleCancel,
  handleClickConfirmationEmailCustomisation,
  id,
  onAttachmentDrop,
  onAttachmentRemove,
  buttonDisabled = false,
  formDisabled = false,
}) => {
  const { classes } = useStyles();

  return (
    <RecordView>
      <FieldRow
        title={`Customise "What to expect now"`}
        tooltipText="Adding text here will replace the default 'What to expect now' section text into the 'Payment received' system email. Change this if you have a specific process you wish to explain to investors once they have made their subscription payment."
        topTitle
      >
        <Controller
          control={control}
          name="whatToExpectNow"
          render={({ field }) => (
            <CkEditor
              disabled={formDisabled}
              onBlur={(value: string) => field.onChange(value)}
              placeholder="We are now processing your application. If any questions arise as we complete this process, our team may contact you. If you do not hear from us, your subscription has been accepted successfully."
              value={field.value}
            />
          )}
        />
      </FieldRow>
      <FieldRow
        title="Add additional attachment"
        informationText="If you wish to add a PDF file to the confirmation email, please attach it here. Please note that the Offering document is automatically attached to this email."
      >
        <Controller
          control={control}
          name="additionalAttachment"
          render={({ field }) => (
            <DropzoneComponent
              name="additionalAttachment"
              accept={{
                'application/pdf': ['.pdf'],
              }}
              onDropFile={onAttachmentDrop}
              disabled={formDisabled}
              files={
                field.value
                  ? [
                      {
                        preview: field.value.previewUri || '',
                        fileName: field.value.fileName,
                      },
                    ]
                  : []
              }
              onRemove={onAttachmentRemove}
            />
          )}
        />
      </FieldRow>

      {!formDisabled && (
        <FieldRow>
          <div className={classes.buttonContainer}>
            <Button variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              className={classes.marginLeftBtn}
              variant="contained"
              color="primary"
              disabled={buttonDisabled}
              onClick={handleClickConfirmationEmailCustomisation}
            >
              {id ? 'Update' : 'Save'}
            </Button>
          </div>
        </FieldRow>
      )}
    </RecordView>
  );
};

export default ConfirmationEmailCustomisation;
